module.exports = __webpack_public_path__ + "static/ready-to-talk-image@2x-3c2b6e18f20f64da8fbf8bbd26329ae4.jpg";